import JSONNET_API_MARKETS from "../constants/JSONNET_API_MARKETS";
import IDimensions from "../model/IDimensions";

export default ({ brand, country, region, language }: IDimensions) => JSONNET_API_MARKETS
  .some(market => (market.brand === brand &&
    market.region === region &&
    market.country === country &&
    market.language === language)
  )
